if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"subPackages","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return false},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}